import { render, staticRenderFns } from "./EventItemPreview.vue?vue&type=template&id=2e81260c&scoped=true"
import script from "./EventItemPreview.vue?vue&type=script&lang=js"
export * from "./EventItemPreview.vue?vue&type=script&lang=js"
import style0 from "./EventItemPreview.vue?vue&type=style&index=0&id=2e81260c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e81260c",
  null
  
)

export default component.exports